

















import { Vue, Component, Prop } from 'vue-property-decorator';
import T from '../../lang';

@Component
export default class LogoutConfirmation extends Vue {
  @Prop({ default: false }) value!: boolean;

  T = T;

  get showModal(): boolean {
    return this.value;
  }

  set showModal(value: boolean) {
    this.$emit('input', value);
  }

  confirmLogout(): void {
    window.location.href = '/logout/';
  }
}
